module.exports = __webpack_public_path__ + "23ce1c79c2ce362e561cfd32ddf6ee99.MP3";